import { fetchWithAuth } from '@/lib/fetchWithAuth';

export interface FinanceiroConfig {
  categorias: string[];
  tiposPagamento: string[];
  formasPagamento: string[];
}

export interface ConfiguracoesFinanceiro {
  contasPagar: FinanceiroConfig;
  contasReceber: FinanceiroConfig;
}

export const DEFAULT_CONFIG: ConfiguracoesFinanceiro = {
  contasPagar: {
    categorias: [
      'Fornecedores',
      'Comissões Parceiros',
      'Comissões Parceiros (Pai)',
      'Comissões Parceiros (Carregadores)',
      'Comissões Vendedores',
      'Impostos',
      'Salários',
      'Aluguel',
      'Serviços',
      'Materiais',
      'Despesa Recorrente',
      'Financiamento',
      'Empréstimos',
      'Deslocamento',
      'Hospedagem',
      'Distribuição de Lucros',
      'Outros'
    ],
    tiposPagamento: ['avista', 'parcelado', 'recorrente'],
    formasPagamento: ['PIX', 'Dinheiro', 'Cartão de Crédito', 'Cartão de Débito', 'Débito em Conta', 'Transferência Bancária', 'Boleto', 'Cheque', 'Outros']
  },
  contasReceber: {
    categorias: [
      'Venda de Sistemas',
      'Instalação',
      'Manutenção',
      'Consultoria',
      'Projetos',
      'Serviços Extras',
      'Outros'
    ],
    tiposPagamento: ['avista', 'parcelado', 'recorrente'],
    formasPagamento: ['PIX', 'Dinheiro', 'Cartão de Crédito', 'Cartão de Débito', 'Débito em Conta', 'Transferência Bancária', 'Boleto', 'Cheque', 'Financiamento Bancário', 'Outros']
  }
};

class ConfiguracoesFinanceiroService {
  private cache: ConfiguracoesFinanceiro | null = null;

  async getConfig(): Promise<ConfiguracoesFinanceiro> {
    if (this.cache) return this.cache;
    try {
      const response = await fetchWithAuth('/api/configuracoes-financeiro');
      if (!response.ok) {
        console.error('Erro na resposta do servidor ao buscar config:', response.status);
        throw new Error('Erro ao buscar configurações financeiro');
      }
      const data = await response.json();
      this.cache = data;
      return data;
    } catch (error) {
      console.error('Usando configuração padrão devido a erro:', error);
      return DEFAULT_CONFIG;
    }
  }

  async saveConfig(config: ConfiguracoesFinanceiro): Promise<void> {
    try {
      const response = await fetchWithAuth('/api/configuracoes-financeiro', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(config)
      });
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        console.error('Erro na resposta do servidor:', errorData);
        throw new Error('Erro ao salvar configurações financeiro');
      }
      this.cache = config;
    } catch (error) {
      console.error('Erro ao salvar configurações financeiro no servidor, atualizando apenas cache local:', error);
      this.cache = config;
      // Removido o throw error para não quebrar a UI, já que estamos salvando no cache local
      // throw error;
    }
  }
}

export const configuracoesFinanceiroService = new ConfiguracoesFinanceiroService();
